import {
  Checkbox,
  Divider,
  Form,
  Input,
  InputNumber,
  Radio,
  Select,
} from "antd";
import React from "react";
import { currencyData } from "../../../../../currency";
import { paymentFrequency, startPeriodOptions } from "../../../../../data";
import { useSelector } from "react-redux";

function EmploymentTerms({ form }) {
  const plainOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];

  const urlExperience = "v1/ap/job-experience";
  const urlJobType = "v1/api/job-types";
  const urlTerms = "v1/ap/terms-of-employment/terms-of-employment";
  const urlStyles = "v1/ap/work-style/work-styles";
  const urlProcess = "v1/ap/recruitment-setup/fetch";

  const { dataExperience, dataJobType, dataTerms, dataStyles, dataProcess } =
    useSelector((state) => ({
      dataExperience: state.dropdown.data[urlExperience] || [],
      dataJobType: state.dropdown.data[urlJobType] || [],
      dataTerms: state.dropdown.data[urlTerms] || [],
      dataStyles: state.dropdown.data[urlStyles] || [],
      dataProcess: state.dropdown.data[urlProcess] || [],
    }));

  const recruitmentOptions = dataProcess?.map((item) => ({
    label: item?.rctName,
    value: item?.rctName,
  }));

  return (
    <>
      <div className="text-[#0B363D] font-[600] text-[1.5rem] font-dmSans mt-[2.5rem]">
        3. Terms of Employment
      </div>
      <div className="mt-[1rem]">
        <Divider />
      </div>
      <div className="mt-[1.5rem] mb-[1.5rem] text-[#0B363D] text-[1.125rem] font-[500] font-dmSans">
        Terms
      </div>
      <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
        <Form.Item
          name="jobJexId"
          className=""
          label={"Experienced required"}
          rules={[
            {
              required: true,
              message: "Please select xxperienced required",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              dataExperience?.length > 0 &&
              dataExperience?.map((item) => ({
                value: item?.jexId,
                label: item?.jexName,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
        <Form.Item
          name="jobPayFrequency"
          className=""
          label={"Payment Frequency"}
          rules={[
            {
              required: true,
              message: "Please select payment frequency",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              paymentFrequency?.length > 0 &&
              paymentFrequency?.map((item) => ({
                value: item?.value,
                label: item?.label,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
        <Form.Item
          name="jobTermId"
          className=""
          label={"Terms of Employment"}
          rules={[
            {
              required: true,
              message: "Please select terms of employment",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              dataTerms?.length > 0 &&
              dataTerms?.map((item) => ({
                value: item?.termId,
                label: item?.termName,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
        <Form.Item
          name="jobWorkStyleId"
          className=""
          label={"Work Style"}
          rules={[
            {
              required: true,
              message: "Please select work Style",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              dataStyles?.length > 0 &&
              dataStyles?.map((item) => ({
                value: item?.workStyleId,
                label: item?.workStyleName,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>

        <Form.Item
          shouldUpdate={(prev, curr) => prev.jobTermId !== curr.jobTermId}
        >
          {({ getFieldValue }) => {
            const selectedId = getFieldValue("jobTermId");

            const selectedTerm = dataTerms?.find(
              (term) => term?.termId === selectedId
            );

            const isContract = selectedTerm?.termName === "Contract";

            if (isContract) {
              return (
                <Form.Item
                  name="jobDuration"
                  label={
                    <span>
                      Length of employment{" "}
                      <span className="text-sm">(months)</span>
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please add length of employment",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    formatter={(value) =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                    className="input flex"
                  />
                </Form.Item>
              );
            }

            return null;
          }}
        </Form.Item>

        <Form.Item
          name="jobStartPeriod"
          className=""
          label={"Start Period"}
          rules={[
            {
              required: true,
              message: "Please select start period",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              startPeriodOptions?.length > 0 &&
              startPeriodOptions?.map((item) => ({
                value: item?.value,
                label: item?.label,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
        <Form.Item
          name="jobJtpId"
          className=""
          label={"Work Type"}
          rules={[
            {
              required: true,
              message: "Please select Work Type",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              dataJobType?.length > 0 &&
              dataJobType?.map((item) => ({
                key: item?.jtpId,
                value: item?.jtpId,
                label: item?.jtpName,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
        <Form.Item
          name="jobCurrency"
          className=""
          label="Gross pay currency"
          rules={[
            {
              required: true,
              message: "Please add gross pay currency",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              currencyData?.length > 0 &&
              currencyData?.map((item) => ({
                value: item?.Ccy,
                label: item?.Ccy,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
        <Form.Item
          label="Salary Confidentiality"
          name="jobSalaryConfidentiality"
          rules={[
            {
              required: true,
              message: "job salary confidentiality required",
            },
          ]}
        >
          <Radio.Group options={plainOptions} />
        </Form.Item>
        <Form.Item
          name="jobGrossPay"
          label="Gross pay"
          rules={[
            {
              required: true,
              message: "Please add gross pay",
            },
          ]}
        >
          <InputNumber
            min={0}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
            className="input flex"
          />
        </Form.Item>
      </div>

      <div className="mt-[1.5rem] mb-[1.5rem] text-[#0B363D] text-[1.125rem] font-[500] font-dmSans">
        Recruitment Proccess
      </div>
      <Form.Item
        label="Select"
        name="jobRecruitmentProcess"
        rules={[
          {
            required: true,
            message: "Select recruitment process",
          },
        ]}
      >
        <Checkbox.Group 
          options={recruitmentOptions}
        />
      </Form.Item>
    </>
  );
}

export default EmploymentTerms;
